import React, { Component } from "react";
import { Table, Button, ButtonGroup, Dropdown } from "react-bootstrap";
import { connect } from "react-redux";
import { setCustomerName } from "../../reducers/actions";
import { utcToLocal } from "../../utils/dateConvert";

class CustomerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "name",
      sortDirection: "asc",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
  }
  componentDidMount() {}
  handleAssetSelection = () => {
    this.props.setCustomerNameAction("abhilash");
  };
  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };

  render() {
    const { customers } = this.props;
    console.log("customers", customers);
    return (
      <Table striped>
        <thead>
          <tr>
            <th>
              Name{" "}
              {this.state.sortString == "name" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${
                    this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                  }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("name");
                  }}
                />
              )}
            </th>
            <th>Description </th>
            <th>
              Status{" "}
              {this.state.sortString == "status" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${
                    this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                  }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("status");
                  }}
                />
              )}
            </th>
            <th>
              Created{" "}
              {this.state.sortString == "created" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${
                    this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                  }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("created");
                  }}
                />
              )}{" "}
            </th>
            <th>
              Updated{" "}
              {this.state.sortString == "updated" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${
                    this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                  }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("updated");
                  }}
                />
              )}{" "}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => {
            return (
              <tr>
                <td>{customer.name}</td>
                <td>{customer.description}</td>
                <td>{customer.status}</td>
                <td>{utcToLocal(customer.dbCreated)}</td>
                <td>{utcToLocal(customer.dbUpdated)}</td>
                <td>
                  <Dropdown as={ButtonGroup}>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={() => this.props.onDetail(customer.id)}
                    >
                      <center>View</center>
                    </Button>

                    <Dropdown.Toggle
                      split
                      variant="primary"
                      id="dropdown-split-basic"
                    />

                    <Dropdown.Menu>
                      <Dropdown.Item href={`/editCustomer/${customer.id}`}>
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/groups?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Group
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/assets?customerId=${customer.id}&customerName=${customer.name}`}
                        onClick={() => {
                          this.handleAssetSelection();
                        }}
                      >
                        Assets
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/users?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Users
                      </Dropdown.Item>
                      <Dropdown.Item
                        href={`/devices?customerId=${customer.id}&customerName=${customer.name}`}
                      >
                        Devices
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}
const mapStateToProps = (state) => ({
  customerName: state.customerName,
});
const mapDispatchToProps = {
  setCustomerNameAction: setCustomerName,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomerTable);
